const SanitizeTextboxInput = (input) => {
  let sanitized = input;

  // 1. Remove non-printable/control characters
  sanitized = sanitized.replace(/[\u0000-\u001F\u007F-\u009F]/g, "");

  // 2. Decode percent-encoded octets like %3C, %7B, etc.
  sanitized = sanitized.replace(/%[a-f0-9]{2}/gi, "");

  // 3. Strip all HTML tags
  sanitized = sanitized.replace(/<\/?[^>]+(>|$)/g, "");

  // 4. Remove angle brackets
  sanitized = sanitized.replace(/</g, "");
  sanitized = sanitized.replace(/>/g, "");

  // 5. Remove line breaks and tabs
  sanitized = sanitized.replace(/[\r\n\t]/g, " ");

  // 6. Replace multiple spaces with a single space
  // sanitized = sanitized.replace(/\s+/g, " ");

  // 7. Trim leading and trailing whitespace
  sanitized = sanitized.replace(/^\s+/, "");

  return sanitized;
}

export default SanitizeTextboxInput;
